import { Booking } from "@ciptex/notified";
import { Anchor } from "@twilio-paste/core/anchor";
import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { FC } from "react";

interface LeaderType {
    booking: Booking | undefined;
  }

export const LeaderInfo: FC<LeaderType> = ({ booking  }) => {
	return (<Box display="flex" flexDirection="row" flexWrap="wrap" flex="9" columnGap="space30" rowGap="space30" alignItems="center">
		{booking?.leader?.firstName && <Text as="p">{booking?.leader?.firstName}</Text>}
		{booking?.leader?.lastName && <Text as="p">{booking?.leader?.lastName}</Text>}
		{booking?.leader?.phone && <Text as="p">{booking?.leader?.phone}</Text>}
		{booking?.leader?.company && <Text as="p">{booking?.leader?.company}</Text>}
		{booking?.leader?.email && <Anchor target="_blank" href={`mailto:${booking?.leader?.email}`}>{booking?.leader?.email}</Anchor>}
	</Box>);
}